document.addEventListener("DOMContentLoaded", function() {
  const items = document.querySelectorAll(".mcr-accordion-item");

  items.forEach(item => {
    const header = item.querySelector(".mcr-accordion-header");

    header.addEventListener("click", () => {
      const isActive = item.classList.contains("active");

      // Close all
      items.forEach(i => {
        i.classList.remove("active");
        const btn = i.querySelector(".mcr-accordion-header");
        btn.setAttribute("aria-expanded", "false");
      });

      // Open clicked (if not active)
      if (!isActive) {
        item.classList.add("active");
        header.setAttribute("aria-expanded", "true");
      }
    });
  });
});